import { render } from "./RecordedInference.vue?vue&type=template&id=642b677f&scoped=true"
import script from "./RecordedInference.vue?vue&type=script&lang=js"
export * from "./RecordedInference.vue?vue&type=script&lang=js"

import "./RecordedInference.vue?vue&type=style&index=0&id=642b677f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642b677f"]])

export default __exports__